import { Component, ViewChildren, OnInit, ApplicationRef } from "@angular/core";
import { Router } from "@angular/router";
import {
  Platform,
  IonRouterOutlet,
  AlertController,
  MenuController,
} from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";
import { ScreenOrientation } from "@ionic-native/screen-orientation/ngx";
import { SwUpdate } from "@angular/service-worker";
import { interval } from "rxjs";
import { first, switchMap } from "rxjs/operators";

import { environment } from "src/environments/environment";

import { LanguageService } from "src/app/services/language.service";
import { AauthService } from "src/app/services/aauth.service";

import { NotificationService } from "src/app/services/notification.service";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent implements OnInit {
  public appPages = [
    {
      title: "MENU_CALENDAR",
      url: "/calendar",
      icon: "calendar-outline",
    },
    {
      title: "TEST_NOW",
      url: "/fertilityCheck",
      image: "assets/images/fcol/icon_square_alt.png",
      // image: 'assets/icons/orion/flat/fertility.svg',
      // icon: 'clipboard-outline'
    },
    {
      title: "MENU_YOUR_FERTILITY",
      url: "/fertility",

      image: "assets/images/fcol/icon_square_2.png",
    },
    {
      title: "MENSTRUATIONS",
      url: "/menstruations",

      icon: "water-outline",
    },
    {
      title: "MENU_DAILY_NOTES",
      url: "/dailyNotes",
      icon: "document-text-outline",
      // icon: 'create-outline'
    },
    {
      title: "MENU_YOUR_HEALTH",
      url: "/health",
      icon: "fitness-outline",
    },
    // {
    //   title: 'MENU_SHOPPING_LIST',
    //   url: '/shopping-list',
    //   icon: 'cart-outline'
    // },
    {
      title: "MENU_PREGNANT_PREPARE",
      url: "/pregnancyPrepare",
      image: "assets/images/fcol/icon_square_3_alt.png",
    },
    {
      title: "MENU_SHARE",
      url: "/share",
      icon: "share-outline",
    },
    {
      title: "MENU_PROFILE",
      url: "/profile",
      icon: "person-outline",
    },
    {
      title: "MENU_ABOUT",
      url: "/about",
      icon: "help-circle-outline",
    },
    // Virou item fixo do menu em app.component.html
    // {
    //   title: 'MENU_LOGOUT',
    //   url: '/logout',
    //   icon: 'log-out-outline',
    //   click: 'logout()'
    // },
  ];

  public appMultilanguage: any;
  public appLogoSmall: any;
  public menuButtonLogout: any;

  private sidebarMenu: any;
  unitData: any = null;

  @ViewChildren(IonRouterOutlet) routerOutlet: IonRouterOutlet;

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private screenOrientation: ScreenOrientation,
    private appRef: ApplicationRef,
    private swUpdate: SwUpdate,
    private languageService: LanguageService,
    private aauthService: AauthService,
    private router: Router,
    private alertController: AlertController,
    private menuController: MenuController,
    private notificationService: NotificationService,
  ) {
    // Carregar variaveis do ambiente
    this.appMultilanguage = environment.appMultilanguage;
    this.appLogoSmall = environment.appLogoSmall;
    this.menuButtonLogout = environment.appMenuButtonLogout;
  }

  async ngOnInit(): Promise<void> {
    // Verificar dados da unidade (em caso de assinaturas cortesia)
    await this.initializeApp();
    this.setupSwUpdates();
  }

  async initializeApp() {
    this.sideMenuInitialize();

    this.platform.ready().then(() => {
      // Inicializar o serviço de idioma
      this.languageService.initialize();

      this.statusBar.backgroundColorByHexString("#031b31"); // funcionaz

      this.statusBar.styleBlackTranslucent();

      // Apenas IOS
      if (this.platform.is("cordova")) {
        if (this.platform.is("ios")) {
          this.statusBar.overlaysWebView(false);
        }

        this.screenOrientation.lock(
          this.screenOrientation.ORIENTATIONS.PORTRAIT,
        );

        // Iniciar o OneSignal
        this.notificationService.initialize(
          environment.onesignalAppId,
          environment.onesinalAndroidId,
        );

        // this.splashScreen.hide();

        // Forçar Portrait
        // if(this.platform.is('android') || this.platform.is('ios')) {

        //   this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);
        //   // Iniciar o OneSignal
        //   this.initializePush();

        // }
      }
    });
  }

  private setupSwUpdates(): void {
    if (!this.swUpdate.isEnabled || this.platform.is("cordova")) {
      return;
    }

    const appIsStable$ = this.appRef.isStable.pipe(
      first((isStable) => isStable),
    );
    const everySixHours$ = interval(6 * 60 * 60 * 1000);

    appIsStable$
      .pipe(switchMap(() => everySixHours$))
      .subscribe(() => this.swUpdate.checkForUpdate());

    this.swUpdate.available.subscribe(async () => {
      const alert = await this.alertController.create({
        message: "Nova versao disponivel. Atualizar agora?",
        buttons: [
          {
            text: "Depois",
            role: "cancel",
          },
          {
            text: "Atualizar",
            handler: async () => {
              await this.swUpdate.activateUpdate();
              document.location.reload();
            },
          },
        ],
      });

      await alert.present();
    });
  }

  async sideMenuActiveItem(event: any) {
    this.sidebarMenu = document.querySelector("#jsmx-sidebarMenu");

    if (this.sidebarMenu != null) {
      const itemActive = this.sidebarMenu.querySelector(".jsmx-itemActive"),
        eventTarget = event.target.closest("ion-item");

      if (await this.menuController.isOpen()) {
        await this.menuController.close();

        if (itemActive != null) itemActive.classList.remove("jsmx-itemActive");

        eventTarget.classList.add("jsmx-itemActive");
      }
    }
  }

  sideMenuInitialize() {
    if (this.sidebarMenu != null) {
      const itemElement = this.sidebarMenu.querySelector("ion-item");

      if (itemElement) {
        itemElement.classList.add("jsmx-itemActive");
      }
    }
  }

  /* Fix para erro:  ionic _before() should be called while animating
    
  https://www.damirscorner.com/blog/posts/20191213-FixForIonic4SideMenuFreezing.html
  codigo: https://bitbucket.org/damir-arh/20191213-ionic-side-menu-freezing/src/master/src/app/app.component.ts
  */
  async closeMenu() {
    if (await this.menuController.isOpen()) {
      await this.menuController.close();
      await this.menuController.enable(false);
    }
  }

  async logout() {
    await this.aauthService.logout();
  }

  async backButton() {
    this.routerOutlet = this.routerOutlet["_results"][0];

    this.platform.backButton.subscribeWithPriority(0, async () => {
      // Caso possa voltar
      if (this.routerOutlet && this.routerOutlet.canGoBack())
        return this.routerOutlet.pop();

      if (
        this.router.url === "/calendar/tabs/main" ||
        this.router.url === "/login" ||
        this.router.url === "/dashboard"
      ) {
        await this.exitApp();
      } else {
        await this.exitApp();
      }
    });
  }

  async exitApp() {
    const alert = await this.alertController.create({
      // header: 'Confirm!',
      message: "Are you sure you want to exit the app?",
      buttons: [
        {
          text: "Cancel",
          role: "cancel",
          cssClass: "secondary",
          handler: (blah) => {},
        },
        {
          text: "Close App",
          handler: () => {
            navigator["app"].exitApp();
          },
        },
      ],
    });
    await alert.present();
  }
}
